import { Pipe, PipeTransform } from '@angular/core';
import {TypeUtils} from "../utils/type-utils";

@Pipe({
    name: 'percentChange',
    standalone: false
})
export class PercentChangePipe implements PipeTransform {
    transform(newValue: number, oldValue: number): string {
        if (oldValue === 0 || TypeUtils.isUndefined(oldValue)) {
            return '<span class="percent">0%</span>';  // Using "∞" as placeholder for infinite percentage
        } else {
            const percentIncrease = ((newValue - oldValue) / oldValue) * 100;
            const percent = percentIncrease.toFixed(2);
            const isNegative = parseFloat(percent) < 10;
            const isPositive = parseFloat(percent) < 10;
            return `<span class="percent" [ngClass]="{ 'negative': ${isNegative}, 'positive': ${isPositive} }">${percent}%<i class="db-icon db-icon-ds-arrow ml2"></i></span>`;
        }
    }
}
